/* ── FAQ accordion custom element ─────────────────────────────── */
class FaqAccordion extends HTMLElement {
  connectedCallback () {
    this.animation = this.dataset.animation || 'slide';
    this.bindItems();
  }

  bindItems () {
    const items = this.querySelectorAll('.faq-item');
    if (this.hasAttribute('data-open-first') && items.length) {
      items[0].setAttribute('open', '');
    }

    items.forEach((item) => {
      const trigger = item.querySelector('.faq-item__trigger');
      const body    = item.querySelector('.faq-item__body');
      if (!trigger || !body) return;
      body.style.height = item.hasAttribute('open') ? 'auto' : '0px';

      trigger.addEventListener('click', (e) => {
        e.preventDefault();
        if (item.hasAttribute('open')) {
          this.closeItem(item, body);
        } else {
          this.closeOthers(item);
          this.openItem(item, body);
        }
      });
    });
  }

  closeOthers (current) {
    this.querySelectorAll('.faq-item[open]').forEach((item) => {
      if (item === current) return;
      const body = item.querySelector('.faq-item__body');
      if (body) this.closeItem(item, body);
    });
  }

  clearPendingEnd (body) {
    if (body._faqOnEnd) {
      body.removeEventListener('transitionend', body._faqOnEnd);
      body._faqOnEnd = null;
    }
  }

  openItem (item, body) {
    this.clearPendingEnd(body);
    item.setAttribute('open', '');
    const target = body.scrollHeight;
    body.style.height = '0px';
    requestAnimationFrame(() => {
      requestAnimationFrame(() => { body.style.height = target + 'px'; });
    });
    body._faqOnEnd = (e) => {
      if (e.propertyName !== 'height') return;
      this.clearPendingEnd(body);
      body.style.height = 'auto';
    };
    body.addEventListener('transitionend', body._faqOnEnd);
  }

  closeItem (item, body) {
    this.clearPendingEnd(body);
    const start = body.scrollHeight;
    if (start === 0) {
      item.removeAttribute('open');
      body.style.height = '0px';
      return;
    }
    body.style.height = start + 'px';
    requestAnimationFrame(() => {
      requestAnimationFrame(() => { body.style.height = '0px'; });
    });
    body._faqOnEnd = (e) => {
      if (e.propertyName !== 'height') return;
      this.clearPendingEnd(body);
      item.removeAttribute('open');
    };
    body.addEventListener('transitionend', body._faqOnEnd);
  }
}

if (!customElements.get('faq-accordion')) {
  customElements.define('faq-accordion', FaqAccordion);
}

if (!customElements.get('details-accordion')) {
  customElements.define('details-accordion', class extends FaqAccordion {});
}

/* ── FAQ tabs (faq-with-tabs section) ─────────────────────────── */
(function () {
  function initFaqTabs (sectionEl) {
    if (!sectionEl) return;

    sectionEl.querySelectorAll('.faq-tabs-root').forEach(function (root) {
      var nav       = root.querySelector('.faq-tabs__nav');
      var tabEls    = Array.from(root.querySelectorAll('.faq-tab'));
      var tabStyle  = root.dataset.tabStyle  || 'underline';
      var showCount = root.dataset.showCount === 'true';
      var showHeading   = root.dataset.showPanelHeading === 'true';
      var panelSubtitle = root.dataset.panelSubtitle || '';

      if (!nav || !tabEls.length) return;

      nav.innerHTML = ''; // safe re-init
      var btns = [];

      tabEls.forEach(function (tab, i) {
        var label = tab.dataset.tabLabel || ('Tab ' + (i + 1));
        var panel = tab.querySelector('.faq-tab__panel');

        // ── Inject panel heading for sidebar / numbered styles ──
        if (showHeading && panel && !panel.querySelector('.faq-tab__panel-header')) {
          var header = document.createElement('div');
          header.className = 'faq-tab__panel-header';

          var h = document.createElement('h3');
          h.className = 'faq-tab__panel-heading mb-3 mb-md-5 overflow-hidden';
          h.textContent = label;
          header.appendChild(h);

          if (panelSubtitle) {
            var sub = document.createElement('p');
            sub.className = 'faq-tab__panel-subtitle mb-4 ';
            sub.textContent = panelSubtitle;
            header.appendChild(sub);
          }

          panel.insertBefore(header, panel.firstChild);
        }

        // ── Build nav button ────────────────────────────────────
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'faq-tab__btn' + (i === 0 ? ' is-active' : '');
        btn.setAttribute('role', 'tab');
        btn.setAttribute('aria-selected', i === 0 ? 'true' : 'false');

        if (tabStyle === 'sidebar') {
          // Label + optional count
          var lbl = document.createElement('span');
          lbl.className = 'faq-tab__btn-label';
          lbl.textContent = label;
          btn.appendChild(lbl);

          if (showCount) {
            var itemCount = tab.querySelectorAll('.faq-item').length;
            if (itemCount > 0) {
              var cnt = document.createElement('span');
              cnt.className = 'faq-tab__btn-count';
              cnt.textContent = itemCount;
              btn.appendChild(cnt);
            }
          }

        } else if (tabStyle === 'numbered') {
          // Number circle + label
          var num = document.createElement('span');
          num.className = 'faq-tab__btn-num';
          num.textContent = i + 1;
          var lbl2 = document.createElement('span');
          lbl2.className = 'faq-tab__btn-label h6';
          lbl2.textContent = label;
          btn.appendChild(num);
          btn.appendChild(lbl2);

        } else {
          // Underline / pill — plain text
          btn.textContent = label;
        }

        btn.addEventListener('click', function () { activate(i); });
        nav.appendChild(btn);
        btns.push(btn);

        // Hide every panel except the first
        if (panel) panel.hidden = (i !== 0);
      });

      function activate (idx) {
        btns.forEach(function (b, i) {
          b.setAttribute('aria-selected', i === idx ? 'true' : 'false');
          b.classList.toggle('is-active', i === idx);
        });
        tabEls.forEach(function (tab, i) {
          var p = tab.querySelector('.faq-tab__panel');
          if (p) p.hidden = (i !== idx);
        });
      }
    });
  }

  function initAllFaqTabs () {
    document.querySelectorAll('.faq-tabs-section').forEach(initFaqTabs);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAllFaqTabs);
  } else {
    initAllFaqTabs();
  }

  function reinitFromEvent (e) {
    var target = e.target && e.target.querySelector
      ? e.target.querySelector('.faq-tabs-section')
      : null;
    if (!target && e.detail && e.detail.sectionId) {
      target = document.querySelector('.faq-tabs-section[data-section-id="' + e.detail.sectionId + '"]');
    }
    if (target) initFaqTabs(target);
  }

  document.addEventListener('shopify:section:load', reinitFromEvent);
  document.addEventListener('shopify:block:select', reinitFromEvent);
})();

/* ── Blog tag-filter "more tags" toggle ───────────────────────── */
(function () {
  function initTagFilter (root) {
    var moreBtn  = root.querySelector('#moreTagsBtn');
    var panel    = root.querySelector('#more-tags');
    var viewLess = root.querySelector('#viewLess');
    if (!moreBtn || !panel || moreBtn.dataset.tagFilterInit) return;
    moreBtn.dataset.tagFilterInit = 'true';

    var hiddenCount = panel.querySelectorAll('button[data-filter]').length;
    var moreLabel   = '+' + hiddenCount + ' More';

    moreBtn.addEventListener('click', function () {
      panel.classList.toggle('active');
      moreBtn.textContent = panel.classList.contains('active') ? 'Hide' : moreLabel;
    });

    if (viewLess) {
      viewLess.addEventListener('click', function () {
        panel.classList.remove('active');
        moreBtn.textContent = moreLabel;
      });
    }
  }

  function initAll () {
    document.querySelectorAll('.sort-filter-wrapper').forEach(initTagFilter);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', initAll);
})();

/* ── Scroll-to-top button ─────────────────────────────────────── */
class ScrollToTop extends HTMLElement {
  connectedCallback () {
    this.button = this.querySelector('.scroll-to-top__button');
    if (!this.button) return;
    this.threshold = 400;
    this.onScroll = this.onScroll.bind(this);
    window.addEventListener('scroll', this.onScroll, { passive: true });
    this.onScroll();
    this.button.addEventListener('click', function () {
      var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      window.scrollTo({ top: 0, behavior: reduce ? 'auto' : 'smooth' });
    });
  }

  disconnectedCallback () {
    window.removeEventListener('scroll', this.onScroll);
  }

  onScroll () {
    var show = window.scrollY > this.threshold;
    this.button.hidden = !show;
    this.button.classList.toggle('is-visible', show);
  }
}

if (!customElements.get('scroll-to-top')) {
  customElements.define('scroll-to-top', ScrollToTop);
}

/* ── Search clear field ───────────────────────────────────────── */
class SearchClearField extends HTMLElement {
  connectedCallback () {
    this.input = this.querySelector('[data-search-input]');
    this.clearBtn = this.querySelector('[data-search-clear]');
    if (!this.input || !this.clearBtn) return;
    this.toggle();
    this.input.addEventListener('input', () => this.toggle());
    this.clearBtn.addEventListener('click', () => {
      this.input.value = '';
      this.toggle();
      this.input.focus();
    });
  }

  toggle () {
    this.clearBtn.hidden = !this.input.value.length;
  }
}

if (!customElements.get('search-clear-field')) {
  customElements.define('search-clear-field', SearchClearField);
}
